<template>
  <div v-if="show" >
        <div class="transaction-detail" >
          ​<a :download="headerData.billDate + '.png'" :href="img" ref="myBtn" style="opactity:0"></a>​​​​​​​​​​​​​​​​​​​​​​​​​​​
            <div class="detail" >
                <div class="detail-print">
                    <div>
                      <img src="@/assets/icon/print.png" alt="" @click="take()"> <small @click="take()">Татах</small>
                    </div>
                    <div>
                        <img src="@/assets/icon/close.png" alt="" @click="close">
                    </div>
                </div>
                <div id="take"  ref="take">
                <div class="detail-header">
                    <span>ДЭЛГЭРЭНГҮЙ МЭДЭЭЛЭЛ</span>
                </div>
                <div class="detail-info" >
                    <div class="detail-shop ">
                      <div class="detail-shop-time">
                        <p>Худалдан авалт</p>
                        <p>{{headerData.billDate}}</p>
                      </div>
                      <hr class="shop-line">
                      <div class="detail-shop-cas">
                        <p>Касс:</p>
                        <p>{{headerData.cashierName}}</p>
                      </div>  
                      <hr class="shop-line">
                      <div class="detail-shop-shop">
                        <p>Дэлгүүр:</p>
                        <p>{{headerData.storeName}}</p>
                      </div>
                      <hr class="shop-line">
                      <div class="detail-shop-shop">
                        <p>Картын дугаар:</p>
                        <p>{{headerData.nominCard}}</p>
                      </div>
                    </div>
                    <div class="detail-bill">
                        <div class="detail-bill-header">
                            <div class="header-one">
                              <p>Барааны нэр</p> 
                            </div>
                            <div class="header-two">
                              <p>тоо</p> 
                            </div>
                            <div class="header-three">
                              <p>Нэгж үнэ</p> 
                            </div>
                            <div class="header-four">
                              <p>нийт үнэ</p> 
                            </div>
                        </div>
                        <div class="detail-bill-body" v-for="(item) in itemData">
                          <div class="detail-bill-body-item">
                            <div class="detail-bill-body-one">
                              <p>{{item.itemName}}</p>
                            </div>
                            <div class="detail-bill-body-two">
                              <p>{{item.qty }}</p>
                            </div>
                            <div class="detail-bill-body-three">
                              <p>{{item.price | pricewithindexof}}</p>
                            </div>
                            <div class="detail-bill-body-four">
                              <p>{{item.totalAmount | pricewithindexof}}</p>
                            </div>
                          </div>
                          <div class="detail-bill-body-info">
                              <div class="detail-bill-body-info-upoint">
                                <div style="margin-top:10px;"><p>ГИШҮҮНЧЛЭЛИЙН ОНОО:</p> <small><p>- {{item.usedBonus | pricewithindex}}</p> <p>+ {{item.addedBonus | pricewithindex}}</p></small></div>
                              </div>
                              <div class="detail-bill-body-info-bonus">
                                
                              </div>
                              <div class="detail-bill-body-info-bbonus">

                              </div>
                          </div>
                          <div class="info-line"></div>
                        </div>
                    </div>
                    <div class="detail-total">
                      <div>
                        <p>Нийт төрөл: <small>{{headerData.resultRowCount}}</small></p>
                      </div>
                      <div>
                        <p>Нийт дүн: <small>{{headerData.totalAmount | pricewithindexof}}</small></p>
                      </div>
                    </div>
                    <div class="detail-board">
                      <div class="detail-board-header" style="height:40px;">
                          <div>
                            <p></p>
                          </div>
                          <div>
                             <p>АШИГЛАХ БОЛОМЖТОЙ ОНОО</p>
                          </div>
                          <div>
                            <p>ХУРИМТЛАГДАЖ БАЙГАА ОНОО</p>
                          </div>
                      </div>
                     
                      <div class="detail-board-header-body">
                        <div class="item-1">
                          <p>АШИГЛАСАН</p>
                        </div>
                        <div class="item-2 minus">
                          <p>-{{headerData.usedBonus | pricewithindex}}</p>
                        </div>
                        <div class="item-3 minus">
                          <p>-{{headerData.usedUPoint | pricewithindex}}</p>
                        </div>
                      </div>
                      <div class="detail-board-header-body">
                        <div class="item-1">
                          <p>НЭМЭГДСЭН</p>
                        </div>
                        <div class="item-2 add">
                            <p>+{{headerData.addedUPoint | pricewithindex}}</p>
                        </div>
                        <div class="item-3 add">
                          <p>+{{headerData.addedBonus | pricewithindex}}</p>
                        </div>
                      </div>
                      
                    </div>
                </div>
                </div>
            </div>
        </div>

  </div>
</template>

<script>
const html2canvas = require('html2canvas');
export default {
    props: {
      show: Boolean,
      headerData:Object,
      itemData: Array,
      coin:Boolean
    },
    data() {
      return {
        number: 0,
        img:'',
        filename:'',
      };
    },
    methods: {
      close() {
        this.$emit("hideModal");
      },
      take(){
        let height = this.$refs.take.clientHeight;
        html2canvas(document.querySelector('#take'),{logging:false,height}).then(
          canvas =>{
            var image = canvas.toDataURL("image/png").replace('image/png','image/octet-stream');
            this.img = image;
           setTimeout(() =>{
              const elem = this.$refs.myBtn;
              elem.click()
           },1500);
          }
        )
      },
    }
};
</script>

<style scoped>
@media only screen and (max-width: 500px) {
  #table1 tr th:nth-child(2){
    width:30px!important;
  }
  #table2 tr th:nth-child(2){
    width:20%!important;
  }
  .print-btn{
    display: none!important;
  }
}
.bold {
  font-weight: bold;
  color: #24292e !important;
}
.table {
  border: 1px solid #ddd;
}
.transaction-detail {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.5);
}
.detail {
  right: 0;
  width: 400px;
  top: 0px;
  height: 100%;
  background: #fff;
  box-shadow: 0px 20px 20px 0 rgba(0, 0, 0, 0.4);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}
.detail::-webkit-scrollbar {
  width: 10px;
}

.detail::-webkit-scrollbar-thumb {
  background: #6690bc;
}
.detail::-webkit-scrollbar-track {
  background: #fff;
}
.detail .detail-header {
  width: 100%;
  margin-bottom:15px;
  height: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.detail .detail-header span:nth-child(1) {
  flex: 1;
  font-size: 18px;
  color: black;
  font-weight: bold;
  display: flex;
  justify-content: center;
}
.detail .detail-header span:nth-child(2) {
  flex: 1;
  font-weight: 300;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
.detail .detail-info {
  margin-top: 10px;
}
.detail thead {
  font-size: 12px;
  padding: 10px;
  text-transform: uppercase;
}
p {
  display: block;
}
.detail thead tr {
  margin: 10px;
}
.detail thead tr th {
  background: #e1e1e1 !important;
  text-align: left;
  font-size: 10px;
  font-weight: bold !important;
  color: #24292e !important;
}
.detail tbody tr td {
  text-align: left;
  font-size: 12px;
  color: #555555;
}
.table th, .table td {
  padding:0!important;
}
.detail tbody tr:nth-child(even) {
  background: #e1e1e1;
}
.print-area {
  margin-bottom: 20px;
}
.print-area button {
  background: #1660ab;
  color: #fff;
  height: 30px;
  font-size: 11px;
  padding: 0px 15px 0px 15px;
  border-radius: 3px;
  margin-left: 4px;
  outline: none;
  border: none;
  cursor: pointer;
  text-transform: uppercase;
}
.table .thead-light th {
  vertical-align: middle;
}
.detail .detail-print {
  width: 100%;
  padding: 10px 0px 10px 10px;
  margin-top: 10px;
  height: auto;
  display: flex;
 justify-content: flex-end;
}
.detail .detail-print div{
    flex:1;
        display: flex;
    justify-content: flex-end;
}
.detail .detail-print div:nth-child(1){
    display: flex;
    padding-left:10px;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
}
.detail .detail-print div:nth-child(1) img{
    width:  16px;
    height: 15px;
   margin-right:8px;
    cursor: pointer;
}
.detail .detail-print div:nth-child(1) small{
  cursor: pointer;
}
.detail .detail-print div:nth-child(1) p{
    margin-bottom:0;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: condensed;
    letter-spacing: normal;
    color: #1660ab;
    margin-left: 5px;
    cursor: pointer;
}
.detail .detail-print div:nth-child(2){
    text-align: right;
    padding-right: 18px;
    cursor: pointer;
    height:13px;
}
.last-line{
    margin-top:28px;
    height:0;
    width:100%;
    background: #ddd;
}


/* New Css */

.detail-info{
  height: auto;
  display:flex;
  flex-direction: column;
}
.detail-shop{
  flex-direction: column;
  padding: 0 20px;
}
.detail-shop-time,.detail-shop-cas,.detail-shop-shop{
  width:100%;
  display: flex;
  flex-direction: row;
  flex-wrap:wrap;
}
.detail-shop-time p,.detail-shop-cas p,.detail-shop-shop p{
  flex:1;
}
.shop-line{
  width:100%;
  /* height: 1px; */
  background-color: #e1e1e1;
  margin:0;
}
.detail-shop-time p:nth-child(1){
  font-family: "Roboto";
  margin-bottom:5px;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: condensed;
  letter-spacing: normal;
  text-align: left;
  color: #24292e;
}
.detail-shop-time p:nth-child(2){
  font-family: "Roboto";
  font-size: 13px;
  margin-bottom:5px;
  font-weight: normal;
  font-style: normal;
  font-stretch: condensed;
  letter-spacing: normal;
  text-align: right;
  color: #1f6ab6;
}
.detail-shop-cas p:nth-child(1){
  font-family: "Roboto";
  margin-bottom:5px;
  margin-top:5px;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(51, 51, 51, 0.8);
}
.detail-shop-cas p:nth-child(2){
  margin-bottom:5px;
  margin-top:5px;
  font-family: "Roboto";
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: right;
  color: #000000;
}
.detail-shop-shop p:nth-child(1){
  margin-bottom:5px;
  margin-top:5px;
  font-family: "Roboto";
  font-size: 10px;
  font-weight: normal;
  text-transform: uppercase;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(51, 51, 51, 0.8);
}
.detail-shop-shop p:nth-child(2){
  margin-bottom:5px;
  margin-top:5px;
  font-family: "Roboto";
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: right;
  color: #000000;
}
.detail-bill{
  width:100%;
}
.detail-bill-header{
  width:100%;
  display: flex;
  height: 32px;
  background-color: #f2f2f2;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  padding:0 20px;
}
.header-one{
  width:50%;
}
.header-two{
  width:10%;
}
.header-three{
  width:20%
}
.header-four{
  width:20%;
}
.header-one p{
  margin-bottom:0;
  font-family: "Roboto";
  text-transform: uppercase;
  font-size: 10px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #24292e;
}
.header-two p{
  margin-bottom:0;
  font-family: "Roboto";
  text-transform: uppercase;
  font-size: 10px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: right;
  color: #24292e;
}
.header-one p{
  padding-left:5px;
}
.header-three p,.header-four p{
  margin-bottom:0;
  font-family: "Roboto";
  text-transform: uppercase;
  font-size: 10px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: right;
  padding-right: 5px;
  color: #24292e;
}
.detail-bill-body{
  width:100%;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}
.detail-bill-body-item{
  margin-top:10px;
  display: flex;
  width: 100%;
  flex-wrap:wrap;
  flex-direction: row;
}
.detail-bill-body-one{
  display: flex;
  align-items: center;
  width:50%;
}
.detail-bill-body-two{
  width:10%;
}
.detail-bill-body-three{
  width:20%;
}
.detail-bill-body-four{
  width:20%;
}
.detail-bill-body-one p{
  padding-left:5px;
  font-family: "Roboto";
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #555555;
  margin-bottom:0;
}
.detail-bill-body-two p{
  font-family: "Roboto";
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: right;
  color: rgba(85, 85, 85, 0.8);
  margin-bottom:0;
}
.detail-bill-body-three p{
  font-family: "Roboto";
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: right;
  color: rgba(85, 85, 85, 0.8);
  margin-bottom:0;
}
.detail-bill-body-four p{
  padding-right:5px;
  font-family: "Roboto";
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: right;
  color: #000000;
  margin-bottom:0;
}
.detail-bill-body-info{
  width:100%;
  display: flex;
  flex-wrap:wrap;
  flex-direction: row;
}
.detail-bill-body-info-upoint{
  width:100%;
}
.detail-bill-body-info-upoint div{
  width:100%;
  padding-left:5px;
  height: 25px;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.detail-bill-body-info-upoint div p:nth-child(1){
  width:30%;
  font-family: "Roboto";
  margin-bottom:0;
  height: 100%;
  font-size: 10px;
  display: flex;
  align-items: center;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(85, 85, 85, 0.8);
}
.detail-bill-body-info-upoint div small{
  width:70%;
}
.detail-bill-body-info-upoint div small p:nth-child(1){
  width:22%;
  font-family: "Roboto";
  margin-bottom:0;
  height: 100%;
  font-size: 12px;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: right;
  color: #000000;
}
.detail-bill-body-info-upoint div small{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 100%;
  align-items: center;
}
.detail-bill-body-info-upoint div small p{
  font-family: "Roboto";
  margin-bottom:0;
  height: 100%;
  font-size: 12px;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: right;
  color: #000000;
}
.detail-total{
  margin-top:10px;
  padding: 0 20px;
  width:100%;
  display: flex;
  flex-wrap:wrap;
  flex-direction: row;
}
.detail-total div{
  flex:1;
  padding-left:5px;
}
.detail-total div:nth-child(2){
  width:100%;
  display: flex;
  justify-content: flex-end;
}
.detail-total div p{
  margin-bottom:0;
  font-family: "Roboto";
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: condensed;
  letter-spacing: normal;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}
.detail-total div p small{
  font-family: "Roboto";
  font-size: 15px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: right;
  color: #000000;
}
.detail-board{
  margin-top:10px;
  width:100%;
  height: auto;
}
.detail-board-header{
  padding:0 20px;
  width:100%;
  height: 32px;
  margin-bottom:10px;
  background-color: #f2f2f2;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}
.detail-board-header div:nth-child(1){
  width:40%;
}
.detail-board-header div{
  width:30%;
}
.detail-board-header div p{
  margin-bottom:0;
  font-family: "Roboto";
  font-size: 11px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}
.detail-board-header-body{
  width:100%;
  display: flex;
  flex-wrap:wrap;
  flex-direction: row;  
  padding: 0 20px;
  height:25px;
}
.detail-board-header-body .item-1{
  width:40%;
  padding-left:5px;
}
.detail-board-header-body .item-2,.detail-board-header-body .item-3,.detail-board-header-body .item-4{
  width:30%;
}
.detail-board-header-body .item-1 p{
  font-family: "Roboto";
  margin-bottom:0;
  font-size: 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(85, 85, 85, 0.8);
}
.detail-board-header-body .item-2,.detail-board-header-body .item-3,.detail-board-header-body .item-4{
  margin-bottom:0;
  font-family: "Roboto";
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}
.minus p{
  color:#f74d75;
}
.add p{
  color:#10beae;
}
.info-line{
  margin-left:5px;
  margin-top:5px;
  height: 1px;
  background: #ddd;
}
.detail-voucher{
  margin-top:20px;
  border-top:1px solid #ddd;
  margin-bottom:50px;
}
.detail-voucher p{
  margin-top:20px;
  font-family: "Roboto";
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: condensed;
  letter-spacing: normal;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}
.detail-voucher-list{
  width:100%;
  display: flex;
  flex-wrap:wrap;
  flex-direction: row;
}
.detail-voucher-list div{
  flex:1;
  font-family: "Roboto";
  font-size: 15px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #000000;
}
.detail-voucher-list div:nth-child(2){
  text-align: right;
}
</style>